"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStableList = void 0;
const react_1 = require("react");
const stableValue_1 = require("../utils/stableValue");
/**
 * A filtered list that keeps its identity until one of ITS items changes.
 *
 * useHouseholdSensors swaps in a new object only for the sensor an update is about (the rest
 * keep theirs) but always hands out a new array, so `useMemo(() => sensors.filter(...),
 * [sensors])` produced a new subset on every update of ANY household sensor and every memo,
 * effect and fetch keyed on it re-ran: a water sensor's report re-rendered the Electrical
 * screen and re-queried its alerts. `useStableList(sensors.filter(...))` returns the previous
 * array while the same sensor objects are in it.
 */
function useStableList(next) {
    const previous = (0, react_1.useRef)(next);
    if (!(0, stableValue_1.sameItems)(previous.current, next))
        previous.current = next;
    return previous.current;
}
exports.useStableList = useStableList;
